import React from "react"
import { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import { LiveId, SelectionId, SpaceKey } from "popopo-msg"
import { useToast } from "popopo-lib-front/hook"
import { api } from "../../core"
import { useAutoUpdateConnection } from "../../lib/useAutoUpdateConnection"

type SelectionSpaceConnectionForms = {
  userId: string
}

export const SelectionSpaceConnectionForm = (props: {
  firebase: User;
  spaceKey: SpaceKey;
  liveId: LiveId;
  selectionId: SelectionId;
}) => {
  const toast = useToast()
  const form = useForm<SelectionSpaceConnectionForms>({
    mode: "onBlur",
  })

  const onConnect = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.POST("/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}/selected-users/me/connection", {
        params: { path: { space_key: props.spaceKey, live_id: props.liveId, selection_id: props.selectionId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          muted: false,
        },
      })
      if (res.error != null) {
        toast.add({ type: "danger", title: "Selection Connection", message: JSON.stringify(res.error) })
      } else {
        toast.add({ type: "success", title: "Selection Connection", message: "Connected successfully" })
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "Selection Connection", message: `Error: ${JSON.stringify(e)}` })
    }
  }

  const updateConnection = async () => {
    const idToken = await props.firebase.getIdToken()
    const res = await api.PUT("/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}/selected-users/me/connection", {
      params: { path: { space_key: props.spaceKey, live_id: props.liveId, selection_id: props.selectionId } },
      headers: {
        authorization: `Bearer ${idToken}`,
      },
      body: {
        muted: false,
      },
    })
    if (res.error != null) {
      throw new Error(JSON.stringify(res.error))
    }
  }

  const onUpdateConnection = async () => {
    try {
      await updateConnection()
      toast.add({ type: "success", title: "Selection Connection", message: "Last connected at updated successfully" })
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "Selection Connection", message: `Error: ${e instanceof Error ? e.message : JSON.stringify(e)}` })
    }
  }

  const { enabled: autoUpdate, setEnabled: setAutoUpdate, lastSentAt: autoUpdateLastSentAt } = useAutoUpdateConnection({
    onUpdate: updateConnection,
    onError: (e) => {
      console.error(e)
      toast.add({
        type: "danger",
        title: "Auto Update Connection",
        message: `自動更新に失敗したため停止しました: ${e instanceof Error ? e.message : JSON.stringify(e)}`,
      })
    },
  })

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onConnect)}>
          Connect
        </button>
        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onUpdateConnection)}>
          Update Connection
        </button>
        <div className="form-check form-switch">
          <input
            id="auto-update-selection-connection"
            type="checkbox"
            className="form-check-input"
            checked={autoUpdate}
            onChange={e => setAutoUpdate(e.target.checked)}
          />
          <label htmlFor="auto-update-selection-connection" className="form-check-label">
            Auto Update Connection (10s 間隔)
          </label>
          {autoUpdate && autoUpdateLastSentAt != null && (
            <small className="d-block text-muted">
              最終送信: {new Date(autoUpdateLastSentAt).toLocaleTimeString()}
            </small>
          )}
        </div>
      </form>
    </>
  )
}
